"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.connectGaToHistory = connectGaToHistory;
exports.trackEvent = trackEvent;
exports.trackException = trackException;
exports.trackPage = trackPage;
var _reactGa = _interopRequireDefault(require("react-ga4"));
function trackPage(page, title) {
  _reactGa.default.send({
    hitType: 'pageview',
    page,
    title
  });
}
function trackEvent(optionsOrName, params) {
  _reactGa.default.event(optionsOrName, params);
}
function trackException(description, fatal = false) {
  _reactGa.default.event('exception', {
    description,
    fatal
  });
}
let previousPath;
function connectGaToHistory(history) {
  history.listen(loc => {
    const currentPath = loc.pathname + loc.hash + loc.search;
    if (previousPath === currentPath) {
      return;
    }
    trackPage(currentPath);
    previousPath = currentPath;
  });
  return history;
}